module.exports = __webpack_public_path__ + "r-v3/img/icon-schedule-doc_green.5ab6f83b.svg";